import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const EducationList = ({ educations, onEdit, onDelete, compact = false }) => {
    if (!educations || educations.length === 0) {
        return (
            <Typography color="textSecondary" className="text-center py-4">
                No education entries added yet
            </Typography>
        );
    }

    if (compact) {
        return (
            <Box>
                {educations.map(edu => (
                    <Box 
                        key={edu.id}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ py: 1, borderBottom: '1px solid', borderColor: 'divider' }}
                    >
                        <Box>
                            <Typography variant="body1">
                                {edu.level}, {edu.field}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {edu.location} • {new Date(edu.start_date).toLocaleDateString()} - {edu.end_date ? new Date(edu.end_date).toLocaleDateString() : 'Present'}
                            </Typography>
                        </Box>
                        {(onEdit || onDelete) && (
                            <Box>
                                {onEdit && (
                                    <IconButton 
                                        size="small" 
                                        onClick={() => onEdit(edu)}
                                        sx={{ mr: 0.5 }}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                )}
                                {onDelete && (
                                    <IconButton 
                                        size="small" 
                                        color="error"
                                        onClick={() => onDelete(edu)}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box>
            {educations.map(edu => (
                <Box 
                    key={edu.id}
                    className="mb-4 p-3 border rounded"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <Box>
                        <Typography variant="subtitle1" className="font-semibold">
                            {edu.level}, {edu.field}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {edu.location}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {new Date(edu.start_date).toLocaleDateString()} - {edu.end_date ? new Date(edu.end_date).toLocaleDateString() : 'Present'}
                        </Typography>
                        {edu.description && (
                            <Typography variant="body2" className="mt-1">
                                {edu.description}
                            </Typography>
                        )}
                    </Box>
                    {(onEdit || onDelete) && (
                        <Box>
                            {onEdit && (
                                <IconButton 
                                    size="small" 
                                    onClick={() => onEdit(edu)}
                                    className="mr-1"
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            )}
                            {onDelete && (
                                <IconButton 
                                    size="small" 
                                    color="error"
                                    onClick={() => onDelete(edu)}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            )}
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
};

export default EducationList; 